// extracted by mini-css-extract-plugin
export var cancelButton = "_lk-5";
export var content = "_lk-3";
export var createButton = "_lk-6";
export var drawerContainer = "_lk-0";
export var footer = "_lk-2";
export var header = "_lk-1";
export var orderFormColumn = "_lk-4";